import { render } from "./AnnouncementToast.vue?vue&type=template&id=e2c47494&scoped=true&ts=true"
import script from "./AnnouncementToast.vue?vue&type=script&lang=ts"
export * from "./AnnouncementToast.vue?vue&type=script&lang=ts"

import "./AnnouncementToast.vue?vue&type=style&index=0&id=e2c47494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c47494"]])

export default __exports__